var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card-text',[_c('h3',{staticClass:"text-secondary"},[_vm._v("You are not allowed to access this list.")])]),_c('i',{staticClass:"fa fa-4x fa-lock text-secondary",attrs:{"aria-hidden":"true"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }